<div class="banner"
  *transloco="let t; lang: 'en|static' read: 'aonhrlearningcenter_directory_aon_com.banner'">
  <img class="left"
    src="assets/themes/aonhrlearningcenter.directory.aon.com/images/aon_header_left.jpg"
    alt="">
  <img class="right"
    src="assets/themes/aonhrlearningcenter.directory.aon.com/images/aon_header_right.jpg"
    alt="">

  <div class="content">
    <h1 class="mat-h1">{{ t('aon_learning_center') }}</h1>
    <div class="mat-h2">{{ t('empowering_hr') }}</div>

    <a href="https://aonahlc.com/"
      target="_blank">
      {{ t('find_out_more') }}
    </a>
  </div>
</div>
